import {
  ShieldCheck, BadgeDollarSign, Wrench, Headphones,
  Music4, Trophy, Newspaper, Mic2, Smartphone, Tv, Car,
  PiggyBank, Radio, MonitorSpeaker, Code2, Layers, LifeBuoy, Cloud,
} from "lucide-react";

export const ICONS = {
  ShieldCheck, BadgeDollarSign, Wrench, Headphones,
  Music4, Trophy, Newspaper, Mic2, Smartphone, Tv, Car,
  PiggyBank, Radio, MonitorSpeaker, Code2, Layers, LifeBuoy, Cloud,
};
